import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { FiMapPin, FiPhoneCall } from "react-icons/fi";


class ContactTab extends Component {
    constructor(props) {
        super(props);
        this.state = { tabIndex: 0 };
    }

    render() {
        const { countries, branches } = this.props;

        return (
            <div>
                <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
                    <div className="row text-center">
                        <div className="col-lg-12">
                            <div className="tablist-inner">
                                <TabList className="pv-tab-button text-center mt--0">
                                    {
                                        countries.map(country => (<Tab key={country.id}><span>{country.name}</span></Tab>))
                                    }
                                </TabList>
                            </div>
                        </div>
                    </div>

                    {
                        countries.reverse().map(country => (
                                <TabPanel key={country.id}>
                                    <div className="container">
                                        <div className="row service-one-wrapper" style={{minHeight: 500}}>
                                            {
                                                branches.filter(branch => branch.countryId === country.id).map(branch => (
                                                    <div key={branch.id} className="col-xl-4 col-lg-4 col-md-6 col-12">
                                                        <div className="service service__style--2">
                                                            <div className="content">
                                                                <h3 className="title">{branch.name}</h3>
                                                                <p><FiMapPin /> {branch.address}</p>
                                                                <p><FiPhoneCall />  {branch.phone}</p>
                                                                <p><a href={`mailto:${branch.email}`}>{branch.email}</a></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </TabPanel>
                        ))
                    }
                </Tabs>
            </div>
        )
    }
}


export default ContactTab
